import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {ThemeProvider} from '@material-ui/core/styles';
import theme from 'styles/theme';
import "./App.scss";
import Flight from "pages/Flight/Loadable";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Switch>
        <Route exact path="/live/flight/:trackingToken" component={Flight}/>
      </Switch>
    </ThemeProvider>
  );
};

export default App;
